export interface CurrencyConfig {
  code: string;
  symbol: string;
  name: string;
  position: 'before' | 'after'; // Symbol position relative to amount
}

export const SUPPORTED_CURRENCIES: Record<string, CurrencyConfig> = {
  USD: {
    code: 'USD',
    symbol: '$',
    name: 'Dólares (USD)',
    position: 'before'
  },
  CRC: {
    code: 'CRC',
    symbol: '₡',
    name: 'Colones (CRC)',
    position: 'before'
  }
};

export const DEFAULT_CURRENCY = 'CRC';

export const SUBSCRIPTION_CURRENCY = 'USD' as const;

export function getCurrencyConfig(currencyCode: string): CurrencyConfig {
  return SUPPORTED_CURRENCIES[currencyCode] || SUPPORTED_CURRENCIES[DEFAULT_CURRENCY];
}

export function formatCurrency(amount: number, currencyCode: string): string {
  const config = getCurrencyConfig(currencyCode);
  const formattedAmount = amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  if (config.position === 'before') {
    return `${config.symbol}${formattedAmount}`;
  } else {
    return `${formattedAmount}${config.symbol}`;
  }
}

export function getCurrencySymbol(currencyCode: string): string {
  return getCurrencyConfig(currencyCode).symbol;
}

export function getCurrencyOptions(): Array<{ value: string; label: string }> {
  return Object.values(SUPPORTED_CURRENCIES).map(currency => ({
    value: currency.code,
    label: currency.name
  }));
}
